import React from 'react';
import PropTypes from 'prop-types';
import download from 'downloadjs';
import clsx from 'clsx';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import CellModal from './CellModal'
import {sendrequest,downrequest,downrequest_pudding,queryrequest_all} from '../services/requestsetting'
import QueryTable from './QueryTableRaw';
import {ResultsTableToolbar} from './ToolBarRaw';

function getTextWidth(longestCellValueDict) {
    /***
     * Create a canvas element in memory to render the
     * longest string in each value of maxCharDict, in
     * order to grab the element width in px. Note we add
     * 50px padding to account for browser rendering differences.
     * @type {{}}
     */
    const maxWidthDict = {}
    const minWidthPx = 150
    Object.keys(longestCellValueDict).forEach(function (key) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext("2d");
        ctx.font = "16px Arial";

        const width = ctx.measureText(longestCellValueDict[key]).width;
        if (width > minWidthPx) {
            maxWidthDict[key] = width + 50
        } else {
            maxWidthDict[key] = minWidthPx
        }
    });

    return maxWidthDict
}

function sanitizeData(rows, maxWidthDict,permission_list) {
    /***
     * Sanitize data (this probably should be done server-side) rows=[{a: 1, b: {}...},{a: 0, b:{}...}...]
     * Replace empty objects with blank strings
     */
    if (typeof rows !== 'undefined' && rows.length > 0) {
        rows=rows.filter(row=>row.archive_id!=null) //filter to remove the record with no archive_id items
        // the array is defined and has at least one element
        const longestCellDict = {}                                  // max number of characters in each column
        Object.keys(rows[0]).forEach(function (key) {
            longestCellDict[key] = key;                             // start with the key (column header)
        });

        rows.map(function (row, i) {                                // iterate over arr (each element is obj)
            for (const [key, value] of Object.entries(row)) {       // for each value in obj
                if (typeof value === 'object' && value !== null) {  // if the value itself is obj
                    if (Object.keys(value).length === 0) {          // and that obj is emptyselect count(i.affiliation)
                        row[key] = '';                              // set it to blank string
                    }
                }
                // if the length of this cell value is longer than the stored value, replace
                if (typeof value === 'string' || typeof value === 'number') {
                    if(longestCellDict[key]!==undefined){
                        if (longestCellDict[key].length < value.toString().length) {
                        longestCellDict[key] = value.toString()
                        }
                    }
                    
                }
            }
            // calculate whether row is proprietary or not
            row['isProprietary'] = isInProprietaryPeriod(row['obs_date'],permission_list, row['type'],row['ProgramID'])
            //row['isProprietary'] = false
            return row
        })
        maxWidthDict = getTextWidth(longestCellDict)
    }
    return {rows, maxWidthDict}
}

function checkProprietaryPeriodFromId(archive_id) {
    const fileDateString = archive_id.slice(0, 6);  // YYMMDD
    const yy = parseInt(fileDateString.substr(0, 2), 10);
    const mm = parseInt(fileDateString.substr(2, 2), 10) - 1;  // zero-based month
    const dd = parseInt(fileDateString.substr(4, 2), 10);

    const yyyy = yy + 2000;

    const fileDate = new Date(yyyy, mm, dd);

    const cutoffDate = new Date();
    cutoffDate.setMonth(cutoffDate.getMonth() - 18);

    // turning off prop check for testing
    return fileDate >= cutoffDate;
    //return false;
}

const isInProprietaryPeriod = (obs_date, permission_list, OBSTYPE = 'OBJECT', programID) => {
    
    // calibration files are not proprietary
    if (OBSTYPE !== 'OBJECT') {
        return false;
    }
    
    // add to check the program ID permission
    if (programID !== '' && permission_list.length > 0 && permission_list.includes(programID)) {
        return false;
    }
    
    try {
        const today = new Date();
        const obsDate = new Date(obs_date);
        
        const beforeModification = new Date(today);
        today.setMonth(today.getMonth() - 18);
        const result = obsDate >= today;

        return result;
    } catch (error) {
        console.error("ERROR in isInProprietaryPeriod:", error);
        return true;
    }
}


const functionerror = () =>{

}

const setcolumns = (rows,maxWidthDict=null) =>{
    let columns = []
    const DefaultColumns =["archive_id",
    "fits_header",
    "ProgramID",
    "AllocationID",
    //"ndf_class",
    "type",
    "OBJECT" ,
    "ra",
    "dec",
    //"EXPOSED",
    "instrument",
    //"GRATID",
    //"DICHROIC",
    "detector",
    "obs_date",
    "targets",
    //"fibre_table",
    "obscore",
    //"topend",
    //"telescope_metadata",
    "filename",
    "isProprietary"
    ] //Object.keys(rows[0]).filter(key => key !== '_id')
        if (typeof rows !== 'undefined') {
            try {
                columns = DefaultColumns.map(item => ({
                    field: item,
                    headerName: item,
                    width:maxWidthDict!==null&&maxWidthDict!==undefined?maxWidthDict[item]:150,
                    minWidth:100,
                    sortable: item.toString() !== 'obscore', //todo remove from all object-type columns
                    filterable: item.toString() !== 'obscore',
                    disableClickEventBubbling: true,
                    renderCell: (params) => (
                        // if item is dictionary and not empty, show a modal dialog with a cell
                        // capable of displaying a tabular version of the contents.
                        <div className={params.row.isProprietary ? "has-background-danger-light" : ''}>
                            {typeof params.value === "object" && params.value !== null ?
                                <CellModal
                                    value={params.value}
                                    title={item.toString()}/>
                                : params.value}
                        </div>
                    ),
                    hide: ['filename', 'isProprietary'].includes(item.toString()),
                    cellClassName: (params) =>
                        clsx({
                            'has-background-danger-light': params.row.isProprietary,
                        }),
                }))
            } catch (e) {
                console.error('error loading colums',e)
            }
        }
    return columns
}

export default class ResultsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectionModel: [],
            selectionModelType: [],
            isDownloading: false,
            isReducing: false,
            rows: [],
            columns: setcolumns([]),
            loading: false,
            maxWidthDict: {},
            proprietarySelectedCount: 0,
            rowCount: 0,
            requestparam: {
                uuid: '',
                next: '',
                previous: ''
            },
            page: 0,
            pageSize: 100,
            query_id: this.props.query_id,
            query: null,
            is_open: false,
            is_query_finished: false,
            nextCursors: {},
            intervalRef: React.createRef()
        };

        this.handleDownload = this.handleDownload.bind(this);
        this.handleDownloadpudding = this.handleDownloadpudding.bind(this);
        this.handleSetSelectionModel = this.handleSetSelectionModel.bind(this);
        this.handleSetIsDownloading = this.handleSetIsDownloading.bind(this);
        this.handlesetResult = this.handlesetResult.bind(this);
        this.handlesetpage = this.handlesetpage.bind(this);
        this.responsequery = this.responsequery.bind(this);
        this.querydataquery = this.querydataquery.bind(this);
        this.handleTabHide = this.handleTabHide.bind(this);
        this.query_all_data = this.query_all_data.bind(this);
        this.handleDownloadFiles = this.handleDownloadFiles.bind(this);
    }

    componentDidMount() {
        if (this.props.query_id !== undefined) {
            this.setState({ requestparam: { uuid: this.props.query_id }, loading: true });
            sendrequest({ uuid: this.props.query_id, request: true }, this.querydataquery, functionerror, this.props.user);
            sendrequest({ uuid: this.props.query_id }, this.responsequery, functionerror, this.props.user);
        } else {
            let resultdata = this.handlesetResult(this.props.data);
            let { rows, maxWidthDict } = sanitizeData(resultdata.results, {}, resultdata.permission_list);
            const columns = setcolumns(rows, maxWidthDict);
            this.setState({ rows: rows, maxWidthDict: maxWidthDict, columns: columns });
        }
    }

    handlesetpage(newPage) {
        const offset = newPage.page * newPage.pageSize;

        const updatedRequest = {
            uuid: this.state.query_id,
            limit: newPage.pageSize,
            offset: offset,
        };

        this.setState({
            page: newPage.page,
            requestparam: updatedRequest,
            loading: true
        }, () => {
            sendrequest(updatedRequest, this.responsequery, functionerror, this.props.user);
        });
    }


    query_all_data = async () => {
        if (this.state.is_query_finished) return;
        if (this.state.rowCount > this.state.rows.length) {
            try {
                const response = await queryrequest_all(this.state.requestparam);
                const data = await response.json();
                if ([200, 202, 304].includes(response.status)) {
                    this.responsequery(data);
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            this.setState({ is_query_finished: true });
        }
    }
    responsequery(data) {
        console.log("=== responsequery called ===");
        console.log("data received: ", data);
        console.log("current page before update: ", this.state.page);
    
        // unwrap first element if data is an array
        const rawData = Array.isArray(data) ? data[0] : data;
    
        // handlesetResult now returns results, permission_list, total_count
        const resultdata = this.handlesetResult(rawData);
    
        // sanitize data for display
        let { rows, maxWidthDict } = sanitizeData(
            resultdata.results || [],
            {},
            resultdata.permission_list || []
        );
    
        // Update state with the new rows, columns, rowCount
        this.setState({
            rows,
            maxWidthDict,
            columns: this.state.columns.length === 0 ? setcolumns(rows, maxWidthDict) : this.state.columns,
            loading: false,
            rowCount: resultdata.total_count || 0,  // <-- used for DataGrid server-side pagination
        });
    
        console.log("rows length:", rows?.length);
        console.log("rowCount:", resultdata.total_count || 0);
    }




    querydataquery(data) {
        const dataquery = data[0].query;
        if (dataquery.obs_date !== undefined) {
            dataquery['start_date'] = dataquery.obs_date;
            dataquery['end_date'] = dataquery.obs_date;
        }
        const query = { ...this.state.querydata, ...dataquery };
        this.setState({ query: query });
    }

    handlesetResult(data) {
        try {
            // unwrap the array if needed
            const rowData = Array.isArray(data) ? data[0] : data;

            if (!rowData || !rowData.results) {
                return { results: [], permission_list: [], total_count: 0 };
            }

            // sanitize the data to generate rows and maxWidthDict
            const { rows, maxWidthDict } = sanitizeData(
                rowData.results,
                {},
                rowData.permission_list || []
            );

            // set rowCount for DataGrid pagination
            const total_count = rowData.count || 0;

            this.setState({
                rows,
                maxWidthDict,
                columns: this.state.columns.length === 0 ? setcolumns(rows, maxWidthDict) : this.state.columns,
                loading: false,
                rowCount: total_count
            });

            this.handleSetSelectionModel(this.state.selectionModel);

            // return the full data including total_count
            return {
                results: rows,
                permission_list: rowData.permission_list || [],
                total_count
            };

        } catch (error) {
            console.error("Error parsing result:", error);
            return { results: [], permission_list: [], total_count: 0 };
        }
    }



handleSetSelectionModel(selectionModel) {
    const MAX_SELECTED = 100;
    const selectedArray = Array.from(selectionModel || []);
    const selected = selectedArray.slice(0, MAX_SELECTED);
    var selectedType = this.state.selectionModelType;

    const prevSelection = new Set(this.state.selectionModel || []);
    const updatedSelection = new Set(prevSelection);

    // Add any new selections from this page
    selected.forEach(id => updatedSelection.add(id));

    // Remove IDs that were previously selected and are now unselected on this page only
    this.state.rows.forEach(row => {
        const id = row.archive_id;
        const wasPreviouslySelected = prevSelection.has(id);
        const isNowSelected = selected.includes(id);
        if (wasPreviouslySelected && !isNowSelected) {
            updatedSelection.delete(id);
            // remove archive id from selectedType
            selectedType = selectedType.filter(object => {
                return object.archive_id !== id;
            })
        }
    });

    // Count proprietary rows and push to 2nd selection model with file type
    let proprietarySelectedCount = 0;

    this.state.rows.forEach(row => {
        const id = row.archive_id;
        if (updatedSelection.has(id)) {
            if (row.isProprietary) {
                proprietarySelectedCount += 1;
            }

        if (!selectedType.some(obj => obj.archive_id === row.archive_id)) {
            selectedType.push({
                archive_id: row.archive_id,
                file_type: row.type,
                isProprietary: row.isProprietary,
            });
            }
        }
    });

    this.setState({
        selectionModel: Array.from(updatedSelection).slice(0, MAX_SELECTED),
        selectionModelType: selectedType,
        proprietarySelectedCount: proprietarySelectedCount,
    });
}


    handleSetIsDownloading(isDownloading) {
        this.setState({isDownloading: isDownloading});
    }
    handleTabHide(){
        this.setState({is_open:!this.state.is_open})
    }

    handleDownloadFiles = async (task_id,file_path) =>{
        //const res = await downrequest({'task_id':task_id},{'file_path':file_path}, {'request_param':'files/'});
        const res = await downrequest({'task_id':task_id, 'file_path': file_path},{'request_param':'files/'});
        const blob = await res.blob();
        // if single file, use that filename! Otherwise assume gzip
        let download_name = 'anu23m_archive_download.tar.gz'
        // if (selected_paths.length === 1) {
        //     download_name = selected_paths[0].split('/')[selected_paths[0].split('/').length-1]
        // }
        download(blob, download_name);
        this.handleSetIsDownloading(false);
    }

    handleDownload = async () => {
        /***
         *
         */
        this.handleSetIsDownloading(true)

        // Call the api with set of ids and ask backend to send a list of files. If there
        // are more than 1 file, zip it.
        alert("It will take some time to process the requested files, please do not refresh or close the page ");
        const selected_paths = []
        const archive_ids=[]
        this.state.selectionModelType.forEach(({ archive_id, file_type, isProprietary }) => {
            if (file_type === 'OBJECT' || file_type === 'ACQ') {
                if (!isProprietary) {
                    archive_ids.push(archive_id);
                }
            } else {
                archive_ids.push(archive_id)
            }
        });
        
        const res = await downrequest({'archive_ids':archive_ids});
        // const blob = await res.blob();
        if (res.status !== 200) {
            alert("Files cannot been downloaded ");
            this.handleSetIsDownloading(false);
            return;
        } else {
            const json=await res.json();
            //TODO edit this so that it doesn't check aganist not_download as its giving an error everytime as it is non-exsistent
            //instead we should check something else
            console.log(json)
            if(json.errors.not_download.length===0)
                alert('Your download request is processing, we will notify you when it is completed.')
            else
                alert('Your download request is processing, we will notify you when it is completed. Some files are proprietary or not be found in server, please contact the observing team to check. Files not downloaded are: '+ json.errors.not_download.toString())
            // check task
            this.state.intervalRef.current = setInterval(async() => {
                const status_res = await downrequest({'task_id':json.task_id},{'request_param':'check_status/'});
                if(status_res.status === 200){
                    const result = await status_res.json();
                    if(result.task_status === 'SUCCESS') {
                        clearInterval(this.state.intervalRef.current);
                        
                        alert('Files are ready to be downloaded now')
                        await this.handleDownloadFiles(json.task_id,result.task_result)
                    }
                }
                
              }, 5000);
        }

    }

    handleDownloadpudding = async () => {
        /***
         * To send request to puddig and get response
         */
        this.setState({isReducing:true})
        const archive_ids=[]
        this.state.selectionModel.forEach(element => {
            for (const row of this.state.rows) {
                // don't push if proprietary
                if (row['archive_id'].toString() === element.toString() && !checkProprietaryPeriodFromId(row['archive_id'])) {
                    archive_ids.push(row['archive_id'])
                    break;
                }
            }
        });
        //telescope is hardcode to aat_archive, will be changed in the future. this is temporary for testing, change it later
        
        const res = await downrequest_pudding({'archive_ids':archive_ids,"username":this.props.user||'bmiszalski',"telescope":'aat_archive'});
        if (res.status !== 200) {
            alert("2dFdr PAWS system offline. Please try again later or contact Data Central");
            this.setState({isReducing:false});
            return;
        } else {
            const json=await res.json();
            try{
                if(json.status==='ok') window.open(json.url, '_blank').focus(); 
                else {
                    alert(json.status_msg);
                }
            }catch{
                alert("Please enable the pop up window for this tab")
            }
            
            //alert("Files start downloading, you should receive email soon about the detail information");
            this.setState({isReducing:false});
        }
    }

    render() {
        const {selectionModel, isDownloading, rows, columns, proprietarySelectedCount,isReducing} = this.state;
        let link= window.location.href.split('/').slice(0, 3).join('/')
        const resultlink=link+'/results/raw/'+this.state.query_id
        return (
            <div className="container" >
                    <div className="message">
                        <div className="message-body">
                            <p>An 18 month proprietary period is in force. Data less than 18 months old can only be
                                distributed
                                to a member of the observing team.&nbsp;
                                If you are a member of an observing team, make sure your team has archive access rights to the program in&nbsp; 
                                <a href="https://lens.datacentral.org.au">LENS</a> under the 2.3m Observing System Management section of your proposal.
                            </p>
                            <p>Proprietary rows are downloadable as part of the csv export functionality, but you cannot
                                download the fits files themselves (note that there is no proprietary period for calibration
                                files).
                                Data that is proprietary is marked with a <span className="has-background-danger-light"> red background </span>.
                            </p>
                            <br/>
                            <p> To access reduced data please visit the <b>Query Reduced Data</b> page in the toolbar above.</p>
                            <br/>
                            {this.state.query_id!==undefined&& <p>Share this result: <a href={resultlink}> {resultlink}</a></p>}
                        </div>
                    </div>
                <QueryTable
                    is_query={false}
                    initialValues={this.state.query}
                    showResetQuestion={false}
                    is_open={this.state.is_open}
                    handleTabHide={this.handleTabHide}
                />
               
                {columns.length>5 && rows.length>0 &&
                <ResultsTableToolbar selected={selectionModel} 
                    rowNumber={rows.length}
                    handleDownload={this.handleDownload}
                    handleDownloadpudding={this.handleDownloadpudding}
                    user={this.props.user}
                    isReducing={isReducing}
                    isDownloading={isDownloading} 
                    proprietarySelectedCount={proprietarySelectedCount}
                    is_query_finished = {this.state.is_query_finished}
                    rowCount={this.state.rowCount}
                                     />
                }
                <div style={rows.length > 0 ? {height: 800, width: '100%'} : {height: 300, width: '100%'}}>
                {columns.length<5?
                    <CircularProgress size={24} style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                    }}/>
                    :
                   <DataGrid
                        scrollbarSize={1}
                        //rows={this.state.rows[0].results}
                        rows={this.state.rows}
                        getRowId={(row) => row.archive_id}
                        columns={columns}
                        paginationMode='server'
                        paginationModel={{ page: this.state.page, pageSize: this.state.pageSize}}
                        pageSizeOptions={[10, 25, 50, 100]}
                        checkboxSelection
                        selectionModel={this.state.selectionModel}
                        rowCount={this.state.rowCount}
                        loading={this.state.loading}
                        keepNonExistentRowsSelected={true}
                        onPaginationModelChange={(model) => this.handlesetpage(model)}
                        onRowSelectionModelChange={(newSelection) => {this.handleSetSelectionModel(newSelection.ids)}}
                        components={rows.length > 0 ? {
                            Toolbar: GridToolbar,
                        }: {}} 
                        sx={{
                            "& .MuiDataGrid-virtualScroller": {
                              overflowX: "scroll"
                            },
                            
                          }}        
                    />}
                </div>
            </div>
        );
    }

}


ResultsTableToolbar.propTypes = {
    selected: PropTypes.array.isRequired,
};
